<template>
    <div class="hello" style="background-color:#f4f5f5; height:100%">
    <van-nav-bar :title="title" left-arrow @click-left="gotohome" />
        <div style="text-align:center; max-width:640px; height:auto; margin: 0 auto; padding: 0 auto; padding-top: 10px; ">
            <div>
                <span  style="color: #606266; font-size:15px;font-weight: 900;">小泉士多 KOIZUMISHOP</span>
            </div>
            <div style="margin-top:10px;">
                <van-image width="128px" height="128px" :src=pic fit="fill" round/>
            </div>
        </div>
        <div>
            <div style="text-align:left; padding-top: 20px; ">
                <span style="color: #606266; font-size:0.6rem; margin-left: 20px;">請先登入會員賬戶，首次登入將自動注冊會員資料:</span>
            </div>
            <div style="text-align:center; max-width:640px; height:300px; margin: 0 auto; padding: 0 auto; padding-top: 10px; ">
                <van-button class="fb-signin-button" @click="clickButton">歡迎使用Facebook登入/注冊</van-button>
                <div>
                    <span  style="color: #606266; font-size:0.5rem;">點擊上方按鈕即表示認同我們的<a style="color:#606266; text-decoration: none;font-size:0.5rem;" href="/terms"></a>《服務條款》及<a style="color:#606266; text-decoration: none;font-size:0.5rem;" href="/privacy">《隱私權政策》</a></span>
                </div>
            </div>
        </div>
        <div style="margin:0 auto; text-align:center; padding-bottom:80px;">
          <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
            <div style="margin-top:20px;">
              <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'facebook',
  data () {
    return {
      title: '登入 / 注冊',
      pic: '/static/koizumishop.png',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    clickButton () {
      var uri = 'https://' + location.host + '/oauth'
      var href = 'https://www.facebook.com/v19.0/dialog/oauth?client_id=252399643816585&&display=popup&scope=email&redirect_uri=' + uri + '&state='
      var params = {uri: uri}

      if (this.redirect) {
        params.redirect = this.redirect
      }

      href += JSON.stringify(params)
      window.location = href
    },
    gotohome () {
      this.$router.go(-1)
      window.scrollTo(0, 0)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  width:90%;
  max-width: 640px;
  padding: 4px 8px;
  border-radius: 3px;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue